export default __webpack_public_path__ + "static/media/trash.a53e2203.svg";